<template>
    <div v-for="guide in recentGuides" :key="guide.id">
        <ShowCardMinimal v-if="use === 'minimal'" :show="guide"/>
        <ShowCard v-else :show="guide"/>
    </div>

</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineProps, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    GetRecentShowGuidesRequest, GetRecentShowGuidesResponse, ShowDto
} from "@/dtos";
import ShowCard from "../ShowCard.vue";
import ShowCardMinimal from "../ShowCardMinimal.vue";

const props = defineProps({
    numOfGuides: {
        type: Number,
        default: 8
    },
    use: {
        type: String,
        default: "card"
    },
})

const use = ref(props.use);

let recentGuides: Ref<ShowDto[]> = ref([]);

onMounted(async () => {
    await getRecentShowsForWidget();
});

const getRecentShowsForWidget = async () => {
    await client.get<GetRecentShowGuidesResponse>(new GetRecentShowGuidesRequest({pageSize: props.numOfGuides}))
        .then(response => {
            recentGuides.value = response.results;
        });
}
</script>
<style>

</style>